import React, { useMemo } from 'react';

import { Select } from '~components';

interface ComponentProps {
  quarter: number;
  year: number;
  onQuarterChange: (quarter: number) => void;
  onYearChange: (year: number) => void;
}

const QUARTERS = [
  { value: 1, label: 'Q1 (Jan–Mar)' },
  { value: 2, label: 'Q2 (Apr–Jun)' },
  { value: 3, label: 'Q3 (Jul–Sep)' },
  { value: 4, label: 'Q4 (Oct–Dec)' },
];

export const QuarterYearSelector: React.FC<ComponentProps> = ({ quarter, year, onQuarterChange, onYearChange }) => {
  const yearOptions = useMemo(() => {
    const thisYear = new Date().getFullYear();
    return Array.from({ length: 5 }, (_, idx) => {
      const yr = thisYear - 2 + idx;
      return { value: yr, label: `${yr}` };
    });
  }, []);
  return (
    <div className="dashboard-quarter-selector" data-cy="dashboard-quarter-selector">
      <Select
        id="dashboard-quarter-select"
        name="dashboard-quarter-select"
        options={QUARTERS}
        value={quarter}
        onChange={(_, value) => onQuarterChange(Number(value))}
        className="quarter"
        placeholder="Select quarter"
      />
      <Select
        id="dashboard-year-select"
        name="dashboard-year-select"
        options={yearOptions}
        value={year}
        onChange={(_, value) => onYearChange(Number(value))}
        className="year"
        placeholder="Select year"
      />
    </div>
  );
};
